export const directoryIconPath = '/Blob/images/job-tile-icons'
export const defaultIconPath = `${directoryIconPath}/brand-hfh.png`

export const mapSectors: { sector: string; fileType: string }[] = [
    { sector: 'technology-digital-health', fileType: 'svg' },
    { sector: 'nursing', fileType: 'svg' },
    { sector: 'allied-health-clinical-support', fileType: 'svg' },
    { sector: 'revenue-cycle-patient-financial-services', fileType: 'svg' },
    { sector: 'physicians', fileType: 'svg' },
    { sector: 'pharmacy', fileType: 'svg' },
    { sector: 'advanced-practice-providers-app-crna', fileType: 'svg' },
    { sector: 'business-administrative-support-services', fileType: 'svg' }
]
